<template>
  <transition name="fade">
    <perfect-scrollbar class="modal" v-if="show">
      <div class="modalOverlay"></div>
      <div class="modalContent">
        <h4>{{title}}</h4>
        <div class="subtitle"
          v-if="1>2">You can edit about donation update information here</div>
        <Editor v-model="form.content.model" :content="form.content.content"/>
        <div class="modalAction">
          <button class="btn btnSecondary" type="button"
            v-on:click="close(false)" v-if="!loading">Cancel</button>
          <button class="btn btnPrimary" :class="{btnLoading: loading}" type="submit"
            v-on:click="handleSubmit">
            <span>Save Changes</span>
          </button>
        </div>
      </div>
      <Confirmation ref="confirmDialog"/>
    </perfect-scrollbar>
  </transition>
</template>

<script>
import Confirmation from '@/components/Confirmation.vue';
import Editor from '@/components/Editor.vue';

export default {
  components: { Editor, Confirmation },
  data() {
    return {
      show: false,
      title: '',
      loading: false,
      next: null,
      saveUri: '',
      form: {
        content: { model: '', content: '' },
      },
    };
  },
  methods: {
    open(d, n) {
      this.next = n;
      this.show = true;
      this.title = d.title;
      this.saveUri = d.saveUri;
      this.loading = false;
      this.form.content.model = (d && d.model) ? d.model : '';
      setTimeout(() => {
        this.form.content.content = this.form.content.model.slice();
      });
    },
    close(b, d) {
      this.show = false;
      if (this.next && typeof this.next === 'function') this.next(b, d);
    },
    handleSubmit() {
      this.loading = true;
      this.$http.post(this.$config.uri(this.saveUri), {
        content: this.form.content.model,
      }).then((r) => {
        this.close(true, r.data.data);
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .modal{
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    z-index: 991;
    .modalOverlay{
      position: fixed;
      top: 0; left: 0; right: 0; bottom: 0;
      background-color: #000;
      opacity: .7;
      z-index: 1;
    }
    .modalContent{
      position: relative;
      background-color: #fff;
      z-index: 2;
      padding: 30px 80px;
      border-radius: 5px;
      overflow: hidden;
      max-width: none;
      width: 640px;
      box-sizing: border-box;
      // top: 50%; left: 50%;
      // transform: translate(-50%, -50%);
      margin: 40px auto;
      h4{
        margin: 0;
        font-size: 24px;
        font-weight: normal;
        margin-bottom: 15px;
        color: #444;
      }
      .subtitle{
        color: #767676;
        margin: -11px 0 20px;
      }
      p{
        margin: 0;
        color: #767676;
      }
      .modalAction{
        margin: 30px -80px -30px;
        padding: 10px 20px;
        text-align: right;
        // background-color: #eee;
        border-top: #eee 1px solid;
        .btn{
          margin-left: 10px;
          &.loading{
            background-color: #ccc;
            color: #999;
            cursor: default;
            box-shadow: none !important;
          }
        }
      }
    }
  }
</style>
